<template>
  <div>
    <div
      class="writing-wrapper"
      :style="{ 'z-index': zindex }"
      @click="handleClose"
    >
      <div class="whiteboard-container">
        <canvas
          :width="canvasWidth"
          :height="canvasHeight"
          :id="canvasid"
          class="canvas"
          :style="{ 'z-index': zindex + 2 }"
        ></canvas>
        <img
          :src="bgImage"
          :width="canvasWidth"
          :height="canvasHeight"
          :style="{ 'z-index': zindex + 1 }"
          class="bg-image"
        />
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/utils/index";
export default {
  data() {
    return {
      nowPage: 0,
      showStep: true, //是否显示动态绘制过程
      isdrawing: false, // 是否是画笔模式
      penWidth: 3,
      penColor: "#E83F3F",
      // 分割线
      canvasWidth: "",
      canvasHeight: "",
      colors: ["#E83F3F", "#2AA5EA", "#4D4D4D"],
      context: {},
      // 存储当前表面状态数组-上一步
      // 配置参数
      config: {
        lineWidth: 3,
        lineColor: "#E83F3F",
        shadowBlur: 2,
      },
      ratio: 1,
    };
  },
  props: {
    canvasid: {
      type: String,
      default: "canvas",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    bgImage: {
      type: String,
      default: "",
    },
    zindex: {
      type: Number,
      default: 2,
    },
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    mobileInfo() {
      let { width, height } = this.$store.state.course.canvasInfo;
      return { width, height };
    },
    pptInfo() {
      return this.$store.state.course.pptInfo;
    },
    imagePreview() {
      return this.$store.state.course.imagePreview;
    },
  },
  mounted() {
    this.initCanvas();
  },
  methods: {
    handleClose() {
      console.log("click canvas mask");
      this.$emit("closeCanvas");
    },
    initCanvas() {
      console.warn("chushihua");
      console.log("mobileInfo", this.mobileInfo);
      var _this = this;
      let opt = this.options;
      const canvas = document.querySelector("#" + this.canvasid);
      const { clientWidth, clientHeight } = document.querySelector(
        ".writing-wrapper"
      );
      // ====
      // let imageSize = utils.resizImage(
      //   this.mobileInfo,
      //   clientWidth,
      //   clientHeight
      // );
      // console.log("imageSize", imageSize);

      // ====
      console.log("client", clientWidth, clientHeight);
      this.context = canvas.getContext("2d");
      let ratio = clientHeight / this.mobileInfo.height;
      this.ratio = ratio;
      this.canvasHeight = clientHeight;
      this.canvasWidth = this.mobileInfo.width * ratio;
      console.log(this.canvasWidth);
      console.log(this.canvasHeight);
      this.context.lineCap = "round";
      this.context.lineJoin = "round";
      this.context.doPath = [];
      this.context.fullPathData = []; //用于记录接收到的“实时画笔传输”的单次作画数据，实时传输的数据是连续的不完整的，这里根据传输状态，记录完整的一次作画数据（鼠标/手指按下作画到抬起）
      this.showStep = opt.showStep ? opt.showStep : this.showStep;
    },
    // 设置绘画配置
    setCanvasStyle() {
      this.context.lineWidth = this.config.lineWidth;
      this.context.strokeStyle = this.config.lineColor;
    },
    //画--type:是否显示每一根线条的绘制动画，true:显示。false:不显示
    drawGraphical: function (data, type) {
      console.log("data:", data.graphtype);
      var graphtype = parseInt(data.graphtype);
      var id = data.id ? data.id : "";
      var color = this.context.strokeStyle;
      if (data.color) {
        color =
          data.color.length == 9 ? "#" + data.color.substr(3, 7) : data.color;
      }
      var weight = data.weight ? parseInt(data.weight) : 0;
      var point = data.point ? data.point : "";
      var deleteId = data.deleteId ? data.deleteId.id : "";

      this.context.lineJoin = "round"; //线的交汇处的样式，miter(尖角，默认)，bevel（斜角）,round（圆角）
      this.context.lineCap = "round"; //线段端点butt：方形,round：圆形,square:方形多一段
      this.context.lineWidth = weight;
      this.context.strokeStyle = color;

      this.context.setLineDash([0, 0]);
      this.context.globalCompositeOperation = "source-over";
      switch (graphtype) {
        case 0:
          //曲线
          this.drawCurve(point, type);
          break;
        case 1:
          //橡皮擦
          this.eraser(point, type);
          break;
        case 2:
          //撤销
          this.redo();
          break;
        case 3:
          //清空画布，保留笔迹历史
          this.clear();
          break;
        default:
          break;
      }
    },
    //曲线
    drawCurve: function (point, type) {
      var _this = this;
      _this.context.beginPath();

      if (type) {
        var i = 1;
        var timer = setInterval(function () {
          if (i < point.length) {
            _this.context.moveTo(
              point[i - 1][0] * _this.ratio,
              point[i - 1][1] * _this.ratio
            );
            _this.context.quadraticCurveTo(
              point[i - 1][0] * _this.ratio,
              point[i - 1][1] * _this.ratio,
              point[i][0] * _this.ratio,
              point[i][1] * _this.ratio
            );
            _this.context.stroke();
            i++;
          } else {
            clearInterval(timer);
            _this.context.closePath();
          }
        }, 1);
      } else {
        _this.context.moveTo(
          point[0][0] * _this.ratio,
          point[0][1] * _this.ratio
        );
        for (var i = 1; i < point.length; i++) {
          //控制点x,y,终点x,y
          _this.context.quadraticCurveTo(
            point[i - 1][0] * _this.ratio,
            point[i - 1][1] * _this.ratio,
            point[i][0] * _this.ratio,
            point[i][1] * _this.ratio
          );
        }
        _this.context.stroke();
        _this.context.closePath();
      }
    },
    dodraw: function (data) {
      //显示线条
      data = data.data;
      // console.log(data.point);
      this.drawGraphical(data, this.showStep);
      if (data.graphtype >= 0 && data.graphtype <= 8) {
        //计入笔迹历史
        if (data.drawstate) {
          //实时传输
          if (data.drawstate == 1) {
            //实时传输，单次作画开始
            this.context.fullPathData = data.point;
          } else {
            this.context.fullPathData = this.context.fullPathData.concat(
              data.point
            );
            if (data.drawstate == 3) {
              //结束
              this.context.doPath.push({
                graphtype: data.graphtype,
                id: data.id,
                color: data.color,
                weight: data.weight,
                point: this.context.fullPathData,
              });
              this.context.fullPathData = [];
            }
          }
        } else {
          //单次完整传输
          this.context.doPath.push({
            graphtype: data.graphtype,
            id: data.id,
            color: data.color,
            weight: data.weight,
            point: data.point,
          });
        }
        // console.log("doPath", this.context.doPath);
      }
    },
    //画笔
    drawPen: function (type, color, weight) {
      var _this = this;
      _this.isClosePen = false;

      //设置颜色和宽度
      _this.context.strokeStyle =
        color.length == 9 ? "#" + color.substr(3, 7) : color;
      _this.context.lineWidth = weight;
      this.context.setLineDash([0, 0]);
      this.context.globalCompositeOperation = "source-over";

      //存储当前画笔信息
      _this.isdrawing = true;
      _this.penWidth = weight;
      _this.penColor = _this.context.strokeStyle;

      // _this.context.canvas.onclick = null; //画笔开启后，原click取消，走画笔的mouseup/touchend，避免事件重复执行

      _this.context.canvas.onmousedown = _this.context.canvas.ontouchstart = function (
        ev
      ) {
        ev.stopPropagation();
        isClick = true;
        if (!_this.isClosePen) {
          var ev = ev || event;
          if (ev.type == "touchstart") {
            ev = ev.changedTouches[0];
          }
          var newLine = {
            type: 10,
            data: {
              graphtype: 5,
              id: new Date().getTime(),
              color: _this.context.strokeStyle,
              weight: _this.context.lineWidth,
              point: [],
              deleteId: {
                id: 0,
              },
            },
            timestamp: new Date().getTime(),
          };
          var newLine2 = {
            type: 10,
            data: {
              graphtype: 5,
              id: new Date().getTime(),
              color: _this.context.strokeStyle,
              weight: _this.context.lineWidth,
              point: [],
              deleteId: {
                id: 0,
              },
              drawstate: 1, //单次作画状态：1.开始画，2.作画中，3.作画结束
            },
            timestamp: new Date().getTime(),
          };
          var parentNode = _this.context.canvas.parentNode;
          var parentTop = (parentLeft = 0);
          if (parentNode.offsetTop > 0 || parentNode.offsetLeft > 0) {
            parentTop = parentNode.offsetTop;
            parentLeft = parentNode.offsetLeft;
          }
          _this.context.beginPath();
          //缩放比例  canvas/实际
          var scaleX =
            _this.context.canvas.getAttribute("width") /
            _this.context.canvas.clientWidth;
          var scaleY =
            _this.context.canvas.getAttribute("height") /
            _this.context.canvas.clientHeight;
          var elem =
            document.scrollingElement ||
            document.documentElement ||
            document.body;
          var scollleft = elem.scrollLeft;
          var scolltop = elem.scrollTop;
          var pointX = parseInt(
            (ev.clientX -
              parseInt($(_this.context.canvas).parent().offset().left) +
              scollleft) *
              scaleX
          );
          var pointY = parseInt(
            (ev.clientY -
              parseInt($(_this.context.canvas).parent().offset().top) +
              scolltop) *
              scaleY
          );
          _this.context.moveTo(pointX, pointY);
          var point = [pointX, pointY];
          newLine.data.point.push(point);
          newLine2.data.point.push(point);

          _this.context.canvas.onmousemove = _this.context.canvas.ontouchmove = function (
            ev
          ) {
            ev.stopPropagation();
            var ev = ev || event;
            if (ev.type == "touchmove") {
              ev = ev.changedTouches[0];
            }
            var elem =
              document.scrollingElement ||
              document.documentElement ||
              document.body;
            var scollleft = elem.scrollLeft;
            var scolltop = elem.scrollTop;
            var pointX = parseInt(
              (ev.clientX -
                parseInt($(_this.context.canvas).parent().offset().left) +
                scollleft) *
                scaleX
            );
            var pointY = parseInt(
              (ev.clientY -
                parseInt($(_this.context.canvas).parent().offset().top) +
                scolltop) *
                scaleY
            );
            _this.context.lineTo(pointX, pointY);
            _this.context.stroke();
            var point = [pointX, pointY];
            newLine.data.point.push(point);
            newLine2.data.point.push(point);
            if (_this.options.penCallBack2 && newLine2.data.point.length > 4) {
              _this.options.penCallBack2(newLine2);
              var lastPoint =
                newLine2.data.point[newLine2.data.point.length - 1];
              newLine2 = {
                type: 10,
                data: {
                  graphtype: 5,
                  id: new Date().getTime(),
                  color: _this.context.strokeStyle,
                  weight: _this.context.lineWidth,
                  point: [],
                  deleteId: {
                    id: 0,
                  },
                  drawstate: 2,
                },
                timestamp: new Date().getTime(),
              };
              newLine2.data.point.push(lastPoint);
            }
          };
          document.onmouseup = _this.context.canvas.onmouseup = _this.context.canvas.ontouchend = function (
            ev
          ) {
            //加document.onmouseup的原因是支持超出画布范围的事件
            ev.stopPropagation();
            document.onmouseup = _this.context.canvas.onmousemove = _this.context.canvas.onmouseup = _this.context.canvas.ontouchmove = _this.context.canvas.ontouchend = null;
            _this.context.closePath();
            if (newLine.data.point.length > 1) {
              //判断是否触发click逻辑
              if (newLine.data.point.length <= 3) {
                for (var i = 1; i < newLine.data.point.length; i++) {
                  if (
                    newLine.data.point[i][0] != newLine.data.point[0][0] ||
                    newLine.data.point[i][1] != newLine.data.point[0][1]
                  ) {
                    isClick = false;
                  }
                }
              } else {
                isClick = false;
              }

              //存入路径数组
              _this.context.doPath.push(newLine.data);
              if (_this.options.penCallBack) {
                _this.options.penCallBack(newLine);
              }
              if (_this.options.penCallBack2) {
                newLine2.data.drawstate = 3; //单次作画状态置为结束
                try {
                  _this.options.penCallBack2(newLine2);
                } catch (e) {}
              }
              ev.preventDefault();
            }
          };
          document.onmousemove = document.ontouchmove = function (ev) {
            _this.context.canvas.onmousemove = _this.context.canvas.ontouchmove = null;
          };
        }
      };
    },
    //橡皮擦-擦除
    eraser: function (point, type) {
      this.context.globalCompositeOperation = "destination-out";
      var _this = this;
      _this.context.beginPath();
      if (type) {
        var i = 1;
        var timer = setInterval(function () {
          if (i < point.length) {
            _this.context.moveTo(point[i - 1][0], point[i - 1][1]);
            _this.context.quadraticCurveTo(
              point[i - 1][0],
              point[i - 1][1],
              point[i][0],
              point[i][1]
            );
            _this.context.stroke();
            i++;
          } else {
            clearInterval(timer);
            _this.context.closePath();
            //如果之前是画笔模式，则继续画笔模式
            if (_this.isdrawing) {
              _this.drawPen(0, _this.penColor, _this.penWidth);
            }
          }
        }, 1);
      } else {
        _this.context.moveTo(point[0][0], point[0][1]);
        for (var i = 1; i < point.length; i++) {
          //控制点x,y,终点x,y
          _this.context.quadraticCurveTo(
            point[i - 1][0],
            point[i - 1][1],
            point[i][0],
            point[i][1]
          );
        }
        _this.context.stroke();
        _this.context.closePath();
        //如果之前是画笔模式，则继续画笔模式
        if (_this.isdrawing) {
          _this.drawPen(5, _this.penColor, _this.penWidth);
        }
      }
    },
    //清空所有的线条数据
    clearPath: function () {
      this.context.doPath = []; //存储所有的线条数据数组
      // console.log("clearAll", this.context.doPath);
    },
    //清空画布
    clearCanvas: function () {
      this.context.clearRect(
        0,
        0,
        this.context.canvas.width,
        this.context.canvas.height
      );
    },
    //清空全部内容
    clear: function () {
      this.clearPath();
      this.clearCanvas();
    },
    //重绘所有线条
    redraw: function () {
      this.clearCanvas(); //清空画板,但不清空存储数组
      if (this.context.doPath.length > 0) {
        // console.log("jinlaile");
        for (var index in this.context.doPath) {
          this.drawGraphical(this.context.doPath[index], false);
        }
      }
    },
    //撤销--清空画板,重绘
    redo: function () {
      // console.log(this.context.doPath);
      this.context.doPath.pop();
      this.redraw();
    },
    handleScale(transform_scale, transform_rotate) {
      const _this = this;
      let PreviewImg = _this.$el.querySelector(".whiteboard-container");
      // console.log("PreviewImg", PreviewImg);
      if (PreviewImg) {
        PreviewImg.style.transform = `scale(${transform_scale}) rotate(${transform_rotate}deg)`;
      }
    },
  },
};
</script>
<style scoped lang="less">
.writing-wrapper {
  width: 100%;
  position: fixed;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 4;
  display: flex;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  .whiteboard-container {
    width: min-content;
    height: 100%;
    position: relative;
    .canvas {
      position: relative;
    }
    .bg-image {
      position: absolute;
      left: 0;
      top: 0;
      background-color: #fff;
    }
  }
}
</style>